import React from 'react';
import { AlertCircle, CheckCircle2, AlertTriangle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { IDS } from '@/constants/testIds/wizard';

export const ValidationPanel = ({ validation }) => {
  const errors = validation?.errors || [];
  const warnings = validation?.warnings || [];
  const ok = validation?.ok;

  return (
    <div className="flex flex-col" data-testid={IDS.right.validation}>
      <div className="panel-header">
        <div className="flex items-center gap-2">
          {validation ? (ok
            ? <CheckCircle2 className="h-4 w-4 text-primary" />
            : <AlertCircle className="h-4 w-4 text-red-400" />)
            : <AlertTriangle className="h-4 w-4 text-muted-foreground" />}
          <span className="panel-title">Validacio</span>
        </div>
        <div className="flex items-center gap-1">
          {validation && (
            <>
              <Badge className={ok ? 'bg-[rgba(0,255,65,0.12)] text-[#7CFF9E] border-[rgba(0,255,65,0.25)]' : 'bg-[rgba(255,77,77,0.12)] text-[#FFB3B3] border-[rgba(255,77,77,0.35)]'}>
                {ok ? 'OK' : 'HIBA'}
              </Badge>
              <Badge variant="outline" className="text-xs">{validation?.stats?.lines || 0} sor</Badge>
            </>
          )}
        </div>
      </div>
      <div className="max-h-40 overflow-y-auto p-2 text-xs space-y-1">
        {!validation && <p className="text-muted-foreground p-2">Generalj vagy importalj G-kodot az ellenorzeshez.</p>}
        {errors.map((e, i) => (
          <div key={`e${i}`} className="flex items-start gap-2 p-2 rounded bg-[rgba(255,77,77,0.08)] border border-[rgba(255,77,77,0.25)]">
            <AlertCircle className="h-3.5 w-3.5 text-red-400 mt-0.5" />
            <span className="text-[11px]">{e}</span>
          </div>
        ))}
        {warnings.map((w, i) => (
          <div key={`w${i}`} className="flex items-start gap-2 p-2 rounded bg-[rgba(255,176,32,0.08)] border border-[rgba(255,176,32,0.25)]">
            <AlertTriangle className="h-3.5 w-3.5 text-amber-400 mt-0.5" />
            <span className="text-[11px]">{w}</span>
          </div>
        ))}
        {validation && ok && errors.length === 0 && warnings.length === 0 && (
          <div className="flex items-center gap-2 p-2 rounded bg-[rgba(0,255,65,0.06)] border border-[rgba(0,255,65,0.25)]">
            <CheckCircle2 className="h-3.5 w-3.5 text-primary" />
            <span className="text-[11px]">Minden rendben - Mach3-ba betoltheto.</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ValidationPanel;
